import {
  CurrencyCode,
  MoneyInput,
  Unit,
} from '@rematter/frontend-lib-api-client';

import { ItemMarginRecord } from '../types/brokeredOrder';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

const toMoneyInput = (
  money:
    | { amount: number; currencyCode: CurrencyCode | string }
    | null
    | undefined,
): MoneyInput | null => {
  if (!money) return null;
  return {
    amount: money.amount,
    currencyCode: money.currencyCode as CurrencyCode,
  };
};

export const brokeredOrderCalculateMarginsQueryAtom = createQueryAtomFactory(
  'brokerage.brokeredOrderCalculateMargins',
  (params: {
    purchaseOrderIds: string[];
    salesOrderIds: string[];
    method: string;
  }) => ({
    tradeBrokeredOrderCalculateMargins: {
      __args: {
        input: {
          purchaseOrderIds: params.purchaseOrderIds,
          salesOrderIds: params.salesOrderIds,
          method: params.method,
        },
      },
      itemId: true,
      quantity: true,
      unit: true,
      purchaseUnitPrice: {
        amount: true,
        currencyCode: true,
      },
      salesUnitPrice: {
        amount: true,
        currencyCode: true,
      },
      purchaseTotal: {
        amount: true,
        currencyCode: true,
      },
      salesTotal: {
        amount: true,
        currencyCode: true,
      },
      margin: {
        amount: true,
        currencyCode: true,
      },
      marginPercent: true,
    },
  }),
  {
    select: (data): ItemMarginRecord[] => {
      if (!data?.tradeBrokeredOrderCalculateMargins) return [];

      return data.tradeBrokeredOrderCalculateMargins.map((item) => ({
        itemId: item.itemId,
        quantity: item.quantity ?? 0,
        unit: item.unit as Unit,
        purchaseUnitPrice: toMoneyInput(item.purchaseUnitPrice),
        salesUnitPrice: toMoneyInput(item.salesUnitPrice),
        purchaseTotal: toMoneyInput(item.purchaseTotal),
        salesTotal: toMoneyInput(item.salesTotal),
        margin: toMoneyInput(item.margin),
        marginPercent: item.marginPercent ?? null,
      }));
    },
  },
);
